<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <servicerequestdetails v-if="isfaq"></servicerequestdetails>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";
export default {
  name: "ServiceRequest",
  components: {
    servicerequestdetails,
  },
  data() {
    return {
      isfaq: true,
    };
  },
};
</script>
